import React, {useEffect } from "react";

import { Link } from 'react-router-dom'
import alertify from 'alertifyjs';

import repository         from './repository';
import { Form, IconList } from '@/componentes/form/styles';
import Template           from '@/modules/admin/template';
import useForm            from '@/componentes/form/useForm';

export function VehicleForm(props) {
    
    const url = "/admin/vehicles";

    const dataInitial = {
        title: "",
        plate: "",
        chassi: "",
        renavam: "",
        yearMod: 0,
        yearFactory: 0,
        speedMax: 0,
        status: true,
        id: 0
    };

    const {values, setValues, handleChange, clearForm} = useForm(dataInitial);
    
    useEffect(() => {

        if (props.match.params.id) {
            
            repository.getView(props.match.params.id, (response) => {

                setValues(response.data);                
            });
        }
   
    }, [props.match.params.id, setValues]);

    const handleSubmit = (e) => {

        e.preventDefault();

        repository.save(values, (response) => {

            alertify.success(response.data.message);
    
            clearForm();
    
            props.history.push(url);
        });
    }

    return (
        <>
            <Template title="Veiculos">

                <Form onSubmit={handleSubmit}>
                    <main className="container">
                        
                        <div className="row">
                            <div className="col-sm-12">
                                <Link to={url}>
                                    <IconList size={30} />
                                </Link>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-sm-6">
                                <label htmlFor="group">Titulo</label>
                                <input type="text" 
                                        name="title" 
                                        id="title" 
                                        maxLength="50" 
                                        value={values.title}
                                        onChange={handleChange} />
                            </div>
                            <div className="col-sm-6">
                                <label>Placa</label>
                                <input type="text" 
                                        name="plate" 
                                        id="plate" 
                                        maxLength="10" 
                                        value={values.plate}
                                        onChange={handleChange} />
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-sm-6">
                                <label htmlFor="group">Chassi</label>
                                <input type="text" 
                                        name="chassi" 
                                        id="chassi" 
                                        maxLength="50" 
                                        value={values.chassi}
                                        onChange={handleChange} />
                            </div>
                            <div className="col-sm-6">
                                <label>Renavam</label>
                                <input type="text" 
                                        name="renavam" 
                                        id="renavam" 
                                        maxLength="50" 
                                        value={values.renavam}
                                        onChange={handleChange} />
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-sm-6">
                                <label htmlFor="group">Ano Fabricação</label>
                                <input type="text" 
                                        name="yearFactory" 
                                        id="yearFactory" 
                                        maxLength="4" 
                                        value={values.yearFactory}
                                        onChange={handleChange} />
                            </div>
                            <div className="col-sm-6">
                                <label>Ano Modelo</label>
                                <input type="text" 
                                        name="yearMod" 
                                        id="yearMod" 
                                        maxLength="4" 
                                        value={values.yearMod}
                                        onChange={handleChange} />
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-sm-6">
                                <label htmlFor="group">Velocidade Máxima</label>
                                <input type="text" 
                                        name="speedMax" 
                                        id="speedMax" 
                                        maxLength="3" 
                                        value={values.speedMax}
                                        onChange={handleChange} />
                            </div>
                            <div className="col-sm-6">
                                <label htmlFor="status">Status</label>
                                <select value={values.status} onChange={handleChange} name="status" id="status" >
                                    <option value={true}>Ativo</option>
                                    <option value={false}>Desativado</option>
                                </select>
                            </div>
                        </div>
                                                                           
                        <div className="row">
                            <button>Salvar</button>
                        </div>
                    </main>
                </Form>
            </Template>
        </>
    )
}

export default VehicleForm;